import { trEnv, isEmptyObj, istEnumAuswahl } from 'ion-lib';
import i18next from 'i18next';
import { generatedStore } from './+config';
import bilder from './assets/img';
import { EnumProduktauswahl } from './components/enum';

/**
 * prüft ob Hausrat
 * @returns {boolean}
 */
const istHausrat = () => {
  const { daten } = generatedStore.getState();
  if (isEmptyObj(daten) || isEmptyObj(daten.produktauswahl)) {
    return false;
  }

  return istEnumAuswahl(daten.produktauswahl, EnumProduktauswahl.HAUSRAT);
};

const setWarningBeratersuche = (string, wagnis) => {
  const {
    strasse, hnr, plz, ort,
  } = wagnis;
  let param = '';
  if (strasse.value && plz.value && ort.value) {
    const wagnisAdresse = window.encodeURI(`${strasse.value} ${hnr.value}, ${plz.value} ${ort.value}`);
    param = `#query=${wagnisAdresse};method=BY_LOCATION;kanal=0,1,5`;
  }

  return string.toString().replace('#BERATERSUCHE#', `<a data-tracking-name="beratersuche" href=${i18next.t('beratersuche', { PARAM: param })} target="_blank">Ansprechpartner vor Ort ></a>`);
};

const setBeratersuche = (string, wagnis, vertreter) => {
  const {
    strasse, hnr, plz, ort,
  } = wagnis;
  let param = '';
  if (!isEmptyObj(vertreter) && vertreter.auswahl.name.value !== '') {
    param = `#query=${vertreter.auswahl.name.value};method=BY_NAME;kanal=0,1,5`;
  } else if (strasse.value && plz.value && ort.value) {
    const wagnisAdresse = window.encodeURI(`${strasse.value} ${hnr.value}, ${plz.value} ${ort.value}`);
    param = `#query=${wagnisAdresse};method=BY_LOCATION;kanal=0,1,5`;
  }

  return i18next.t(string, { PARAM: param });
};

const getBannerFileName = () => {
  if (!trEnv.sparkasse) {
    return null;
  }

  switch (trEnv.mandant) {
    case 'oesa':
      if (istHausrat()) {
        return bilder.bannerOESAhr;
      }
      return bilder.bannerOESAglas;
    case 'oevb':
      if (istHausrat()) {
        return bilder.bannerOEVBhr;
      }
      return bilder.bannerOEVBglas;
    case 'oevo':
      if (istHausrat()) {
        return bilder.bannerOEVOhr;
      }
      return bilder.bannerOEVOglas;
    default:
      if (istHausrat()) {
        return bilder.bannerVGHhr;
      }
      return bilder.bannerVGHglas;
  }
};

export {
  setWarningBeratersuche,
  setBeratersuche,
  getBannerFileName,
  istHausrat,
};
